export enum InvestigationStatus {
  OPEN = 1,
  IN_PROGRESS = 2,
  CLOSED = 3,
}

export enum AssignedUserType {
  UNASSIGNED = '000000000000000000000001',
  USER_OUTSIDE_MY_COMPANY = '000000000000000000000002',
  CURRENT_USER = '000000000000000000000003',
}

export enum InvestigationPriority {
  CRITICAL = 4,
  HIGH = 3,
  MEDIUM = 2,
  LOW = 1,
  UNKNOWN = 0,
}
